import { render, staticRenderFns } from "./FeatureAwards.vue?vue&type=template&id=bd80b9c0&scoped=true&"
import script from "./FeatureAwards.vue?vue&type=script&lang=js&"
export * from "./FeatureAwards.vue?vue&type=script&lang=js&"
import style0 from "./FeatureAwards.vue?vue&type=style&index=0&id=bd80b9c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd80b9c0",
  null
  
)

export default component.exports